<template>
  <div class="service-rate">
    <van-rate v-model="score" color="#ed5c00" :readonly="readonly" :size="size" />
    <div>{{score ? score.toFixed(1) : 0}}<label class="score-num">{{totalScoreNum}}人评分</label></div>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      default: 0,
    },
    totalScoreNum: {
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style lang="scss" scoped>
.service-rate{
  font-size: small;
  color: #666;
  display: flex;
  text-align: center;
  align-items: center;
}
.score-num{
  padding-left: .3rem;
}
</style>




// WEBPACK FOOTER //
// src/components/ServiceRate.vue